import { log } from "@lululemon/mwa-utils";
import * as React from "react";

import withReduxStore from "@lululemon/ecom-common/src/store/with-redux-store";
import { Meganav } from "@lululemon/meganav";
import { SimpleHeader } from "@lululemon/simple-nav";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import HeaderBanner from "../header-banner/header-banner";
import { publicConfig } from "../../util/public-config";

import DynamicLinkProvider from "../dynamic-link-provider/index";
import { SCROLLING_DOWN, useScrollDirection } from "./use-scroll-direction";
import { useLaunchDarklyFlag } from "@lululemon/mwa-launch-darkly";

const HeaderBannerWithReduxStore = withReduxStore((props) => (
  <HeaderBanner {...props} />
));

HeaderBannerWithReduxStore.displayName = "HeaderBannerWithReduxStore";

export function WrappedMegaNav(props) {
  const { isSignpostingBarVisible } = props;
  const { deviceType } = useDeviceType();
  const isMobileOrTablet = deviceType?.isMobile || deviceType?.isTablet;
  const headerRef = React.useRef();
  const { query, asPath, locale } = useRouter();

  const newguestWelcomeOfferBanner = useLaunchDarklyFlag(
    "newguest-welcome-offer-banner",
    false,
    publicConfig?.launchDarkly?.webCommerceExperiencesClientId
  );

  const scrollDirection = useScrollDirection();

  const consumerConfig = {
    apiHost: publicConfig.apiHost,
    apiHostBasePath: publicConfig.apiHostBasePath,
    googleMapsApiKey: publicConfig.googleMapsApiKey,
    launchDarkly: publicConfig.launchDarkly.nav,
    links: publicConfig.links,
  };

  const getStyle = () => {
    const headerOffset = "34px";

    if (isSignpostingBarVisible && scrollDirection === SCROLLING_DOWN) {
      return {
        transform: isMobileOrTablet
          ? "translateY(0%)"
          : `translateY(calc(-100% + ${headerOffset}))`,
        ...(isMobileOrTablet && { position: "sticky" }),
      };
    }

    return {};
  };

  const style = getStyle();

  if (query.contentOnly === "true") return null;

  if (
    asPath.match(/^[a-zA-Z0-9.\/\:]*\/story\/bra-quiz$/) &&
    isMobileOrTablet
  ) {
    return <SimpleHeader />;
  }

  return (
    <DynamicLinkProvider>
      <Meganav
        consumerConfig={consumerConfig}
        ref={headerRef}
        style={style}
        renderBanner={(banners) => {
          return (
            <HeaderBannerWithReduxStore
              headerRef={headerRef.current}
              banners={banners}
              isWelcomeOfferEnabled={newguestWelcomeOfferBanner}
              locale={locale}
            />
          );
        }}
        onErrorCallback={(error) =>
          log.error("An error occurred when rendering MegaNav", error)
        }
      >
        <div id="signposting" />
      </Meganav>
    </DynamicLinkProvider>
  );
}

WrappedMegaNav.propTypes = {
  isSignpostingBarVisible: PropTypes.bool,
};

WrappedMegaNav.defaultProps = {
  isSignpostingBarVisible: false,
};

function mapStateToProps({ rootReducer }) {
  return {
    isSignpostingBarVisible: rootReducer.headerBanner.isSignpostingBarVisible,
  };
}

export default connect(mapStateToProps)(WrappedMegaNav);
